import { IPdfOptions, IPdfRow, TPdfOptionKey } from "@services/pdf/types"

export type TBuilderStep = "builder" | "preview"

export interface IBuilderState {
	step: TBuilderStep
	coverRow: IPdfRow
	contentRows: IPdfRow[]
	options: IPdfOptions
}

export type TBuilderAction =
	| { type: "togglePage"; rowId: string; pageId: string }
	| { type: "setCoverTitle"; title: string }
	| { type: "setRowInput"; rowId: string; value: string }
	| { type: "moveRow"; from: number; to: number }
	| { type: "toggleOption"; option: TPdfOptionKey }
	| { type: "setStep"; step: TBuilderStep }

export function builderReducer(state: IBuilderState, action: TBuilderAction): IBuilderState {
	switch (action.type) {
		case "togglePage": {
			// cover row: exclusive select, tapping the selected page deselects it (iOS CoverCell)
			if (action.rowId === state.coverRow.id) {
				return {
					...state,
					coverRow: {
						...state.coverRow,
						pages: state.coverRow.pages.map((page) => ({
							...page,
							isSelected: page.id === action.pageId ? !page.isSelected : false,
						})),
					},
				}
			}
			// artwork/attachment rows: independent checkboxes (iOS ArtworkCell)
			return {
				...state,
				contentRows: state.contentRows.map((row) => {
					if (row.id !== action.rowId) {
						return row
					}
					return {
						...row,
						pages: row.pages.map((page) =>
							page.id === action.pageId ? { ...page, isSelected: !page.isSelected } : page
						),
					}
				}),
			}
		}
		case "setCoverTitle": {
			return { ...state, coverRow: { ...state.coverRow, customInput: action.title } }
		}
		case "setRowInput": {
			return {
				...state,
				contentRows: state.contentRows.map((row) =>
					row.id === action.rowId ? { ...row, customInput: action.value } : row
				),
			}
		}
		case "moveRow": {
			const rows = [...state.contentRows]
			const [moved] = rows.splice(action.from, 1)
			rows.splice(action.to, 0, moved)
			return { ...state, contentRows: rows }
		}
		case "toggleOption": {
			const active = state.options.activeOptions.includes(action.option)
			return {
				...state,
				options: {
					...state.options,
					activeOptions: active
						? state.options.activeOptions.filter((o) => o !== action.option)
						: [...state.options.activeOptions, action.option],
				},
			}
		}
		case "setStep": {
			return { ...state, step: action.step }
		}
		default:
			return state
	}
}
